import ACTIONS from "../actions";

const initialState = {
  prospects: [],
  totalProspects: 0,
};

const prospectReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.GET_PROSPECTS:
      return {
        ...state,
        prospects: payload.prospects,
        totalProspects: payload.totalProspects,
      };
    default:
      return state;
  }
};
export default prospectReducer;
